<template>
    <div class="apps-container">
      <div class="apps-list">
        <TransitionGroup name="apps-collapse" tag="div" style="display: contents;">
            <a-tag class="info-modal--tag" v-for="app in visibleApps" :key="app.application_id">
                {{ app.name }}
                <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
            </a-tag>
        </TransitionGroup>
        <a-button v-if="apps.length > appsShown" type="link" @click="() => isAllAppsShown = !isAllAppsShown" style="max-height: 26px;">
            {{ viewText }}
        </a-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'appsCollapse',
  props: {
    apps: {
      type: Array,
    },
    appsShown: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      isAllAppsShown: false,
    }
  },
  computed: {
    viewText() {
      return this.isAllAppsShown ? 'Hide' : 'View all'
    },
    visibleApps() {
      return this.isAllAppsShown ? this.apps : this.apps.slice(0, 3)
    },
  },
  methods: {

  },
}
</script>
<style lang="scss" src="./style.module.scss" />
